/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { Modal, Table } from 'antd'
import { col_service } from '../../../components/CommonTable/columns'
export default class extends React.Component {
  render() {
    const { visible, list, serviceList } = this.props
    //回合消费
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '用户',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '球台',
        dataIndex: 'table_name',
        key: 'table_name',
      },
      {
        title: '开始时间',
        dataIndex: 'start_time',
        key: 'start_time',
      },
      {
        title: '结束时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '原价',
        dataIndex: 'origin_price',
        key: 'origin_price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
      {
        title: '奖金',
        dataIndex: 'profit',
        key: 'profit',
      },
    ]
    //商品消费
    const columnsCommodity = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '用户',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '商品名称',
        dataIndex: 'c_name',
        key: 'c_name',
      },
      {
        title: '球台',
        dataIndex: 'table_name',
        key: 'table_name',
      },
      {
        title: '购买时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
    ]

    return (
      <div>
        <Modal
          title="消费详情"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1300px"
        >
          <Table
            rowKey="id"
            title={() => {
              return '回合消费'
            }}
            columns={columns}
            dataSource={list.list}
            pagination={{ pageSize: 5 }}
            size="middle"
          />
          <Table
            rowKey="id"
            title={() => {
              return '商品消费'
            }}
            columns={columnsCommodity}
            dataSource={list.goodsList}
            pagination={{ pageSize: 5 }}
            size="middle"
          />
          <Table
            rowKey="id"
            title={() => {
              return '服务消费'
            }}
            columns={col_service}
            dataSource={serviceList}
            pagination={{ pageSize: 5 }}
            size="middle"
          />

          <p>
            <span style={{ marginRight: '20px' }}>
              名称: {this.props.selected_nickname}
            </span>
            <span style={{ marginRight: '20px' }}>
              支付账号: {this.props.selected_account}
            </span>
            <span>付款金额: ￥{list.prices}</span>
          </p>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/modalDetail.js